export default {
    realm: {},
    urls: [
        {
            url: '/clans/%(clanId)s/members/',
            method: 'DELETE',
            key: 'remove_member',
        },
        {
            url: '/clans/%(clanId)s/members/',
            method: 'PATCH',
            key: 'change_role',
        },
        {
            url: '/clans/%(clanId)s/members/',
            method: 'PATCH',
            key: 'change_commander',
        },
        {
            url: '/clans/%(clanId)s/treasury/',
            method: 'PUT',
            key: 'divide_profits',
        },
    ],
}



// WEBPACK FOOTER //
// ./containers/ClanManagement/settings.js